import { LegalDocument } from "@/features/legal/components/LegalDocument";

export function TermsPage() {
  return <LegalDocument document="terms" />;
}
